export const getTabARIA = ({ index, uniqueId }: { index?: number; uniqueId: string }) => {
  const tabpanelId = `clay-tabpanel-${uniqueId}-${index}`;
  const tabId = `clay-tab-${uniqueId}-${index}`;

  return {
    tab: {
      id: tabId,
      "aria-controls": tabpanelId,
    },
    tabpanel: {
      id: tabpanelId,
      "aria-labelledby": tabId,
    },
  };
};
